import React, { createContext, useState, useContext } from 'react';

const AvatarContext = createContext();

export const AvatarProvider = ({ children }) => {
  const [avatarSettings, setAvatarSettings] = useState({
    style: localStorage.getItem('avatarStyle') || 'avataaars',
    bgColor: localStorage.getItem('avatarBgColor') || 'b6e3f4',
    seed: localStorage.getItem('avatarSeed') || '1234',
    name: localStorage.getItem('advisorName') || '王曉明',
  });

  const updateAvatarSettings = (newSettings) => {
    setAvatarSettings(newSettings);
  };

  return (
    <AvatarContext.Provider value={{ avatarSettings, updateAvatarSettings }}>
      {children}
    </AvatarContext.Provider>
  );
};

export const useAvatar = () => useContext(AvatarContext); 